import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './CompanyIntro.css';
import { motion } from 'framer-motion';
import { slideInLeft, slideInRight, fadeInUp } from '../../styles/animations';
import { Link } from 'react-router-dom';

const CompanyIntro = () => {
  return (
    <section className="company-intro">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-4 mb-lg-0">
            <motion.div className="intro-image-wrapper" variants={slideInLeft} initial="hidden" whileInView="visible" viewport={{ once: true }}>
              <div className="intro-image"></div>
              <div className="intro-experience">
                <span className="years">5+</span>
                <span className="text">Years of Experience</span>
              </div>
            </motion.div>
          </Col>
          <Col lg={6}>
            <motion.div className="section-heading" variants={slideInRight} initial="hidden" whileInView="visible" viewport={{ once: true }}>
              <span className="subtitle">About Lyros Technologies</span>
              <h2>Empower Your Business with Exceptional Talent Resources</h2>
            </motion.div>
            <motion.p className="intro-text" variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
              Lyros Technologies is a leading provider of innovative technology solutions, helping businesses 
              across various industries to transform and grow in the digital era. With over a decade of 
              experience, we have established ourselves as trusted partners for organizations seeking to 
              leverage technology for competitive advantage.
            </motion.p>
            <motion.p className="intro-text" variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
              Our team of experts specializes in workforce management, global technology services, and IT/ITES 
              solutions tailored to meet the unique needs of each client. We are committed to delivering 
              excellence and driving sustainable growth for our clients.
            </motion.p>
            <motion.div variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
               <Button as={Link} to="/aboutus" variant="primary">
                      Learn More About Us
                    </Button> </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CompanyIntro;